/**
 * Identidade da tentativa de venda — a chave da idempotência do PDV.
 *
 * O mesmo valor é repetido em toda retentativa do MESMO carrinho e só muda
 * quando a venda fecha. É isso que deixa o servidor reconhecer o reenvio e
 * devolver a venda já gravada em vez de criar outra — o caso em que a resposta
 * se perdia depois do commit e o estoque baixava duas vezes.
 */

const CHAVE_UUID = "osp_pos_client_uuid";

/**
 * UUID v4 que funciona TAMBÉM fora de contexto seguro.
 *
 * `crypto.randomUUID` só existe em HTTPS ou localhost. Uma loja que serve o
 * sistema em http://192.168.x.x — segundo terminal na rede da loja, cenário
 * comum — cairia no fallback; e um fallback que não gera UUID de verdade faz o
 * backend recusar com 422 e o balcão para de vender. `getRandomValues` existe em
 * contexto inseguro, então a formatação é feita à mão a partir dele.
 */
export function uuidV4() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  const b = new Uint8Array(16);
  crypto.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40;   // versão 4
  b[8] = (b[8] & 0x3f) | 0x80;   // variante RFC 4122
  const h = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");

  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/**
 * Persiste em sessionStorage porque a reação humana a "erro ao finalizar" é
 * apertar F5. Guardado só em memória, o recarregamento gerava identidade nova,
 * o servidor não reconhecia nada e a venda entrava duas vezes — exatamente o que
 * a idempotência existe para impedir.
 */
export function lerOuCriarClientUuid() {
  try {
    const salvo = sessionStorage.getItem(CHAVE_UUID);
    if (salvo) return salvo;
    const novo = uuidV4();
    sessionStorage.setItem(CHAVE_UUID, novo);

    return novo;
  } catch {
    return uuidV4();   // modo privado: sem persistência, mas ainda válido
  }
}

/** Próxima venda, nova identidade. */
export function rotacionarClientUuid() {
  const novo = uuidV4();
  try { sessionStorage.setItem(CHAVE_UUID, novo); } catch { /* segue sem persistir */ }

  return novo;
}
